<template lang="pug">
  shListData(title="Prices History" resolver="pricesHistory" keyData="_id" component="shPrice" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'PricesHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/price/PricesHistory.vue